import "./index.scss";

import { Stack } from "@mui/material";
import Button from "components/Button";
import ScreenLoader from "components/ScreenLoader";
import WorkoutPlanEditModal from "containers/MemberDetails/WorkoutPlanEditModal";
import WorkoutPlanSection from "containers/MemberDetails/WorkoutPlanSection";
import { WorkoutPlan as TWorkoutPlan } from "models/workoutplan";
import { getLkpGoalsList } from "modules/lookup/lookupServices";
import {
  getLkpFlexibilityStretchesLowerBodyList,
  getLkpFlexibilityStretchesUpperBodyList,
  getLkpPerceivedExertionList,
  getWorkoutPlanById,
} from "modules/workout-plan/workoutPlanServices";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function WorkoutPlanView() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [showEditWorkoutPlanModal, setShowEditWorkoutPlanModal] = useState(false);
  const [currentWorkoutPlan, setCurrentWorkoutPlan] = useState<TWorkoutPlan>();
  const [lkpGoalsOptions, setLkpGoalsOptions] = useState([]);
  const [flexibilityUpperBodyStretchesOptions, setFlexibilityUpperBodyStretchesOptions] = useState(
    []
  );
  const [flexibilityLowerBodyStretchesOptions, setFlexibilityLowerBodyStretchesOptions] = useState(
    []
  );
  const [perceivedExertionOptions, setPerceivedExertionOptions] = useState([]);

  //#region Preparing data needed
  useEffect(() => {
    setLoading(true);
    let promises: Promise<any>[] = [];

    //Get member workout plan
    promises.push(
      new Promise((resolve) => {
        getWorkoutPlanById({ workout_plan_id: id }).then((res) => {
          if (res.data) {
            setCurrentWorkoutPlan(res.data);
            //Get other data related to workout plan
            let subPromises: Promise<any>[] = [];

            //Get plan info goals' list
            subPromises.push(
              getLkpGoalsList().then((res) => {
                if (res.success) {
                  let goals: any[] = [];
                  Object.keys(res.data).forEach((e) => {
                    goals.push({ label: res.data[e], value: e });
                  });
                  setLkpGoalsOptions(goals);
                }
              })
            );

            //Get flexibility upper body stretches' list
            subPromises.push(
              getLkpFlexibilityStretchesUpperBodyList().then((res) => {
                if (res.success) {
                  setFlexibilityUpperBodyStretchesOptions(res.data);
                }
              })
            );

            //Get flexibility lower body stretches' list
            subPromises.push(
              getLkpFlexibilityStretchesLowerBodyList().then((res) => {
                if (res.success) {
                  setFlexibilityLowerBodyStretchesOptions(res.data);
                }
              })
            );

            //Get list for perceivedExertionOptions
            subPromises.push(
              getLkpPerceivedExertionList().then((res) => {
                if (res.success) {
                  let entries: any[] = [];
                  Object.keys(res.data).forEach((e) => {
                    entries.push({ label: `${e} - ${res.data[e]}`, value: e });
                  });
                  setPerceivedExertionOptions(entries);
                }
              })
            );

            Promise.all(subPromises).then((_v) => {
              resolve(true);
            });
          } else {
            resolve(false);
          }
        });
      })
    );

    Promise.all(promises).then((_v) => {
      setLoading(false);
    });
  }, [id]);
  //#endregion Preparing data needed

  //#region event handlers
  const handleCloseModal = (isRefreshNeeded = false) => {
    setShowEditWorkoutPlanModal(false);
    if (typeof isRefreshNeeded == "boolean" && isRefreshNeeded) {
      setLoading(true);
      window.location.reload();
    }
  };
  //#endregion event handlers

  return (
    <>
      <Stack className="manage-circuit-container">
        <Stack direction={"row"} alignItems="center" justifyContent={"space-between"}>
          <h2 className="workoutPlanTemplatePageHeader">Workout Plan Template Details</h2>
          {!loading && (
            <Button
              label={"Edit"}
              color="primary-blue"
              className="margin-0"
              onClick={() => setShowEditWorkoutPlanModal(true)}
            />
          )}
        </Stack>
        {loading && <ScreenLoader isScreenLoader />}
        {!loading && (
          <WorkoutPlanSection
            workoutPlan={currentWorkoutPlan}
            goalOptions={lkpGoalsOptions}
            upperBodyStretchOptions={flexibilityUpperBodyStretchesOptions}
            lowerBodyStretchOptions={flexibilityLowerBodyStretchesOptions}
            perceivedExertionOptions={perceivedExertionOptions}
          />
        )}
        ;
      </Stack>
      <WorkoutPlanEditModal
        open={showEditWorkoutPlanModal}
        onClose={handleCloseModal}
        workoutPlanId={+id}
      />
    </>
  );
}

export default WorkoutPlanView;
